import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { S3_BUCKET_URL } from "@Shared/utils/constants";
import ChatMessage from "./ChatMessage.vue";
import { mapState } from "vuex";
import { handleChat, updateChatInteraction } from "../store/chat-bot-actions.ts";
// const baseMessage =
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "ChatBot",
  components: {
    ChatMessage
  },
  props: {
    status: {
      type: String,
      // required: true, TODO: remove when done
      default: "clear",
      validator: function (value) {
        const validStatuses = ["past-due", "active", "upcoming", "planned", "clear"];
        return _includesInstanceProperty(validStatuses).call(validStatuses, value);
      }
    },
    badgeCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      messages: [{
        message: this.$t("global.messages.proChatHelloMessage"),
        id: "aa23",
        localUser: false
      }],
      currentMessage: "",
      loading: false,
      popoverShow: false,
      currentInteraction: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails", "accountDetails", "permissions", "selectedApplicationId"])), {}, {
    imgSrc() {
      return `${S3_BUCKET_URL}/assets/ChatIcon.ico`;
    },
    isMobile() {
      return window.innerWidth <= 760;
    }
  }),
  methods: {
    onClose() {
      this.popoverShow = false;
      this.clearChat();
    },
    async handleSendMessage() {
      if (this.currentMessage) {
        var _context;
        this.messages.push({
          message: this.currentMessage,
          id: uuidv4(),
          localUser: true
        });
        this.currentMessage = "";
        setTimeout(() => {
          this.scrollToBottom();
        }, 100);
        this.loading = true;
        let payload = {
          messages: _mapInstanceProperty(_context = this.messages).call(_context, message => ({
            message: message.message,
            localUser: message.localUser
          })),
          fullName: `${this.userDetails.givenName} ${this.userDetails.familyName}`
        };
        if (this.currentInteraction) payload = _objectSpread(_objectSpread({}, payload), {}, {
          interactionId: this.currentInteraction
        });
        const response = await handleChat(payload);
        this.currentInteraction = response.interactionId;
        delete response.interactionId;
        this.messages.push(_objectSpread({
          id: uuidv4()
        }, response));
        setTimeout(() => {
          this.scrollToBottom();
        }, 100);
        this.loading = false;
      }
    },
    async vote(values) {
      const msgsToUpdate = this.messages;
      msgsToUpdate[values.index] = _objectSpread(_objectSpread({}, msgsToUpdate[values.index]), {}, {
        vote: values.vote
      });
      this.messages = msgsToUpdate;
      const payload = {
        interactionId: this.currentInteraction,
        messages: this.messages
      };
      await updateChatInteraction(payload);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.messageContainer.scrollTop = this.$refs.messageContainer.scrollHeight;
      });
    },
    clearChat() {
      this.messages = [{
        message: this.$t("global.messages.proChatHelloMessage"),
        id: "aa23",
        localUser: false
      }];
      this.currentInteraction = null;
      this.loading = false;
    }
  }
});